export default __webpack_public_path__ + "static/media/customize_file.7f1b0b80.svg";